import { useState, type FormEvent } from "react";
import { auth } from "../../../config/firebase";
import { useTeam } from "../../../contexts/TeamContext";
import { addTeamWithJoinCode } from "../../../services/queries/joinCodeQueries";
import styles from "../components/TeamSettings.module.css";

export type AddTeamModalProps = {
  onClose?: () => void;
};

const normalizeTeamName = (value: string) => value.trim().toLowerCase();

const SubscribeModal = ({ onClose }: AddTeamModalProps) => {
  const { organizationId, teams } = useTeam();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Enter a team name");
      return;
    }
    const uid = auth.currentUser?.uid;
    if (!uid) {
      setError("You must be signed in");
      return;
    }
    if (!organizationId) {
      setError("No organization selected");
      return;
    }

    const key = normalizeTeamName(trimmed);
    const list = Array.isArray(teams) ? teams : [];
    if (
      key &&
      list.some(
        (t: { name?: string }) => normalizeTeamName(t?.name ?? "") === key
      )
    ) {
      setError("A team with this name already exists");
      return;
    }

    setSubmitting(true);
    setError(null);
    try {
      await addTeamWithJoinCode({
        name: trimmed,
        organizationId,
      });
      setName("");
      onClose?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to add team");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      className={styles["team-settings-invite-form"]}
      onSubmit={handleSubmit}
    >
      <h2 className={styles["team-settings-invite-form-title"]}>Add team</h2>

      <div className={styles["team-settings-invite-form-content"]}>
        <label htmlFor="add-team-name">This is premium feature</label>
        {error ? (
          <p style={{ margin: 0, color: "#c0392b", fontSize: 14 }}>{error}</p>
        ) : null}
      </div>
    </form>
  );
};

export default SubscribeModal;
